var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "reset-regist" } },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("section", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "input_list" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_c("label", [_vm._v(_vm._s(_vm.label.password))])]),
              _vm._v(" "),
              _c("li", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.userForm.password,
                      expression: "userForm.password",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: {
                    type: "password",
                    placeholder: "********",
                    maxlength: "20"
                  },
                  domProps: { value: _vm.userForm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userForm,
                        "password",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("li", [
                _c("label", [_vm._v(_vm._s(_vm.label.confirmPassword))])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.userForm.confirmPassword,
                      expression: "userForm.confirmPassword",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: {
                    type: "password",
                    placeholder: "********",
                    maxlength: "20"
                  },
                  domProps: { value: _vm.userForm.confirmPassword },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userForm,
                        "confirmPassword",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm.errors.password
              ? _c("div", [
                  _c("label", { staticClass: "error_text" }, [
                    _vm._v(_vm._s(_vm.errors.password))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.errors.confirmPassword
              ? _c("div", [
                  _c("label", { staticClass: "error_text" }, [
                    _vm._v(_vm._s(_vm.errors.confirmPassword))
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control_btn_area" }, [
            _c(
              "div",
              {
                staticClass: "main_btn sel_sub_btn",
                on: {
                  click: function($event) {
                    _vm.confirm()
                  }
                }
              },
              [_c("a", [_vm._v("設定")])]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h1", [_vm._v("新しいパスワードを設定")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "manual" }, [
      _c("label", { staticClass: "bold" }, [
        _vm._v(
          "半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ab7e4b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab7e4b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcPasswordResetUpdate.vue
// module id = null
// module chunks = 